import { Sparkles } from "lucide-react";

/**
 * Small, contained live preview of the Announcement Banner — mirrors the
 * public EmiTickerBanner's visuals/animation exactly, using the CURRENT
 * (unsaved) draft values so admins can see changes before publishing.
 */
export default function EmiTickerPreview({ messages, speedSeconds, direction, separator }) {
  const active = (messages || []).filter((m) => m.enabled !== false && m.text?.trim());
  const items = active.length > 0 ? active : [{ id: "empty", text: "(no active messages)" }];
  const speed = Number(speedSeconds) > 0 ? Number(speedSeconds) : 45;
  const dir = direction === "right" ? "right" : "left";
  const sep = separator || "·";
  const repeated = Array.from({ length: 3 }).flatMap(() => items);

  return (
    <div>
      <p className="text-[10.5px] tracking-[0.2em] uppercase mb-2" style={{ color: "var(--ax-text-muted)" }}>
        Live preview
      </p>
      <div
        data-testid="cms-banner-preview"
        className="relative w-full overflow-hidden rounded-lg border-y"
        style={{ borderColor: "rgba(212,175,110,0.25)", background: "linear-gradient(90deg, #0a0a0c, #1a1409, #0a0a0c)" }}
      >
        <div className="flex justify-center overflow-hidden">
          <div
            className="flex items-center gap-10 py-2.5 whitespace-nowrap"
            style={{
              width: "max-content",
              animation: `cms-banner-preview-scroll ${speed}s linear infinite`,
              animationDirection: dir === "right" ? "reverse" : "normal",
            }}
          >
            {repeated.map((m, i) => (
              <span key={`${m.id || m.text}-${i}`} className="inline-flex items-center gap-2.5 text-[11px] tracking-[0.16em] uppercase text-amber-200/90">
                <Sparkles className="w-3 h-3 text-gold shrink-0" />
                <span>{m.text}</span>
                <span className="text-gold/40">{sep}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes cms-banner-preview-scroll {
          from { transform: translate3d(0,0,0); }
          to { transform: translate3d(-33.333%,0,0); }
        }
      `}</style>
    </div>
  );
}
